import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeleteReportComponent } from './delete-report/delete-report.component';
import { ModalLayoutComponent } from './modal-layout/modal-layout.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ConfirmCloseModalComponent } from './confirm-close-modal/confirm-close-modal.component';
import { InfoModalComponent } from './info-modal/info-modal.component';
import { RecipientRepositoryModalComponent } from './recipient-repository-modal/recipient-repository-modal.component';
import { InfoLinkModalComponent } from './info-link-modal/info-link-modal.component';
import { AppMaterialModule } from '../app-material.module';
import { ViewReportComponent } from './view-report/view-report.component';
import { CoreModule } from '@core';
import { UiModule } from '../../ui.module';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { DirectivesModule } from '../directives/directives.module';
import { CreateMultipleEntityComponent } from './create-multiple-entity/create-multiple-entity.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ErrorModalComponent } from './error-modal/error-modal.component';
import { DocumentModalComponent } from './document-modal/document-modal.component';
import { NewBillingListComponent } from './new-billing-list/new-billing-list.component';
import { MoveReportComponent } from './move-report/move-report.component';
import { EditGroupAgreementComponent } from './edit-group-agreement/edit-group-agreement.component';
import { HtmlEditorComponent } from './html-editor/html-editor.component';
import { ManagementSideBarComponent } from './management-side-bar/management-side-bar.component';
import { AddSharedUserComponent } from './add-shared-user/add-shared-user.component';
import { ConfirmDeleteCommentComponent } from './confirm-delete-comment/confirm-delete-comment.component';
import { SendToComponent } from './send-to/send-to.component';
import { ConfirmDeleteSharedComponent } from './confirm-delete-shared/confirm-delete-shared.component';
import { ExportReportsModalComponent } from './export-reports-modal/export-reports-modal.component';
import { AddReportBillingListModalComponent } from './add-report-billing-list-modal/add-report-billing-list-modal.component';
import { ChangeReportStatusComponent } from './change-report-status-modal/change-report-status.component';
import { BillingCommentComponent } from './billing-comment/billing-comment.component';
import { CreateUniformComponent } from './create-uniform/create-uniform.component';
import { DocumentTypeChooseComponent } from './pdf-type-choose/document-type-choose.component';
import { DeleteEntityComponent } from './delete-entity/delete-entity.component';
import { DeleteTaxDocumentComponent } from './delete-tax-document/delete-tax-document.component';
import { LinkedPaymentsModalComponent } from './linked-payments-modal/linked-payments-modal.component';
import { LinkPaymentsComponent } from './link-payments/link-payments.component';
import { ConfirmDeleteGeneralRowComponent } from './confirm-delete-general-row/confirm-delete-general-row.component';
import { LinkToPdfTdModalComponent } from './link-to-pdf-td-modal/link-to-pdf-td-modal.component';
import { PullEntireBalanceComponent } from './pull-entire-balance/pull-entire-balance.component';
import { ValidateClosePiComponent } from './validate-close-pi/validate-close-pi.component';
import { RouterModule } from '@angular/router';
import { NoticeUnlinkPaymentsRefundComponent } from './notice-unlink-payments-refund/notice-unlink-payments-refund.component';
import { LinkedDocumentsTdComponent } from './linked-documents-td/linked-documents-td.component';
import { ConfirmSaveNotificationsComponent } from './confirm-save-notifications/confirm-save-notifications.component';
import { DashboardSideModalComponent } from './dashboard-side-modal/dashboard-side-modal.component';
import { DeleteEntityAdditionalInfoComponent } from './delete-entity-additional-info/delete-entity-additional-info.component';
import { EntityAdditionalInfoModalComponent } from './entity-additional-info-modal/entity-additional-info-modal.component';
import { MigrationsInAppComponent } from './migrations-in-app/migrations-in-app.component';
import { DuplicateEntityModalComponent } from './duplicate-entity-modal/duplicate-entity-modal.component';
import { FolderModalComponent } from './folder-modal/folder-modal.component';
import { ChangeVatStatusComponent } from './change-vat-status/change-vat-status.component';
import { LinkToAgreement } from '@ui/lib/shared-modules/modals/attach-to-agreement/link-to-agreement.component';
import { InputsModule } from '@app/shared/ui/components/inputs/inputs.module';
import { BookkeepingPeriodComponent } from '@ui/lib/shared-modules/modals/bookkeeping-period/bookkeeping-period.component';
import { DefaultConfirmCloseComponent } from '@ui/lib/shared-modules/modals/default-confirm-close/default-confirm-close.component';
import { NewUiModule } from '@app/shared/ui/new-ui.module';
import { SubmitButtonModule } from '@app/shared/ui/components/buttons/submit-button/module/submit-button.module';
import { DatepickerInputModule } from '@app/shared/ui/components/inputs/datepicker/module/datepicker-input.module';
import { CrmProcessComponent } from '@ui/lib/shared-modules/modals/crm-process/crm-process.component';
import { DropdownMenuInputModule } from '@app/shared/ui/components/inputs/dropdown-menu/module/dropdown-menu-input.module';
import { AddClauseModalComponent } from '@ui/lib/shared-modules/modals/add-clause-modal/add-clause-modal.component';
import { MatterBudgetItemModalComponent } from '@ui/lib/shared-modules/modals/matter-budget-item-modal/matter-budget-item-modal.component';
import { FreeTextInputModule } from '@app/shared/ui/components/inputs/free-text/module/free-text-input.module';
import { AutocompleteModule } from '@app/shared/ui/components/inputs/autocomplete/module/autocomplete.module';
import { AddEntriesToInvoiceComponent } from '@ui/lib/shared-modules/modals/add-entries-to-invoice/add-entries-to-invoice.component';
import { ReportingPeriodComponent } from '@ui/lib/shared-modules/modals/reporting-period/reporting-period.component';
import { AddStageModalComponent } from '@ui/lib/shared-modules/modals/add-stage/add-stage-modal.component';
import { UpdateClausesModalComponent } from '@ui/lib/shared-modules/modals/update-clauses/update-clauses-modal.component';
import { AddReportsModalComponent } from '@ui/lib/shared-modules/modals/add-reports/add-reports-modal.component';
import { AddPersonnelModalComponent } from '@ui/lib/shared-modules/modals/add-personnel/add-personnel-modal.component';
import { FileUploaderModule } from '@app/shared/ui/components/inputs/file-uploader/module/file-uploader.module';
import { AddUserRoleHistoryModalComponent } from '@ui/lib/shared-modules/modals/add-user-role-history/add-user-role-history-modal.component';
import { ClientsAndMattersCommentsSideModalComponent } from '@ui/lib/shared-modules/modals/clients-and-matters-comments-side-modal/clients-and-matters-comments-side-modal.component';
import { AddAgreementSplitModalComponent } from '@ui/lib/shared-modules/modals/add-agreement-split/add-agreement-split-modal.component';
import { NewReportModalComponent } from '@ui/lib/shared-modules/modals/new-report/new-report-modal.component';
import { TextareaInputModule } from '@app/shared/ui/components/inputs/textarea-input/module/textarea-input.module';
import { BranchSelectComponent } from '@ui/lib/shared-modules/modals/branch-select/branch-select.component';
import { NewConfirmCloseModalComponent } from '@ui/lib/shared-modules/modals/new-confirm-close/new-confirm-close-modal.component';
import { TimePickerModule } from '@app/shared/ui/components/inputs/time-picker/module/time-picker.module';
import { IframeModalComponent } from '@ui/lib/shared-modules/modals/iframe-modal/iframe-modal.component';
import { NewSharedModule } from '@app/shared/new-shared.module';
import { StageTemplatesModalComponent } from '@ui/lib/shared-modules/modals/stage-templates/stage-templates-modal.component';
import { SuggestionCardModule } from '@app/shared/ui/components/suggestion-card/module/suggestion-card.module';
import { DropdownModule } from '@ui/lib/shared-components/dropdown/dropdown.module';
import { ExistingContactComponent } from '@ui/lib/shared-modules/modals/existing-contact/existing-contact.component';
import { AddClassifiedUserComponent } from '@ui/lib/shared-modules/modals/add-classified-user/add-classified-user.component';
import { RadioGroupModule } from '@app/shared/ui/components/inputs/radio-group/module/radio-group.module';
import { AddInteractionModalComponent } from '@ui/lib/shared-modules/modals/add-interaction/add-interaction-modal.component';
import { CheckboxModule } from '@app/shared/ui/components/inputs/checkbox/module/checkbox.module';
import { TaskModalComponent } from '@shared/modals/task-modal/task-modal.component';
import { TabsModule } from '@app/shared/ui/components/tabs/module/tabs.module';
import { TextareaInputActionsModule } from '@app/shared/ui/components/inputs/textarea-input-actions/module/textarea-input-actions.module';
import { ApplyTemplateModalComponent } from '@ui/lib/shared-modules/modals/apply-template/apply-template-modal.component';
import { UpdateVatModalComponent } from '@ui/lib/shared-modules/modals/update-vat/update-vat-modal.component';
import { NewDropdownModule } from '@app/shared/ui/components/inputs/new-dropdown/module/new-dropdown.module';
import { RangeCalendarModule } from '@app/shared/ui/components/inputs/range-calendar/module/range-calendar.module';
import { RemindersModule } from '@app/pages/tasks/components/reminders/module/reminders.module';
import { IncomeSplitModalComponent } from '@ui/lib/shared-modules/modals/income-split-modal/income-split-modal.component';
import { IconButtonComponent } from '@app/shared/ui/components/buttons/icon-button/icon-button.component';
import { MaterialSpinnerModule } from '@ui/lib/shared-components/material-spinner/module/material-spinner.module';
import { AgGridRootModule } from '@app/shared/ag-grid/ag-grid.module';
import { AddDocumentsModalComponent } from '@ui/lib/shared-modules/modals/add-document-to-task/add-documents-modal.component';
import { CommentsSideModalComponent } from '@ui/lib/shared-modules/modals/comments-side-modal/comments-side-modal.component';
import { GenericFormModalComponent } from '@ui/lib/shared-modules/modals/generic-form-modal/generic-form-modal.component';
import { NewDynamicFormModule } from '@app/shared/new-dynamic-form/new-dynamic-form.module';
import { ImportFileModalComponent } from '@ui/lib/shared-modules/modals/import-file/import-file-modal.component';
import { DatesCalculatorModalComponent } from '@ui/lib/shared-modules/modals/dates-calculator-modal/dates-calculator-modal.component';
import { FormLayoutModule } from '@app/shared/components/new-drawer/form-layout/module/form-layout.module';
import { AlertModalComponent } from '@ui/lib/shared-modules/modals/alert-modal/alert-modal.component';
import { AlertSendingExplanationComponent } from '@ui/lib/shared-modules/modals/alert-modal/alert-sending-explanation/alert-sending-explanation.component';
import { NewMatterAlertModalComponent } from '@ui/lib/shared-modules/modals/new-matter-alert-modal/new-matter-alert-modal.component';
import { NewMobileVersionModalComponent } from '@ui/lib/shared-modules/modals/new-mobile-version/new-mobile-version-modal.component';
import { BulkActionModalComponent } from '@ui/lib/shared-modules/modals/bulk-action-modal/bulk-action-modal.component';
import { TransactionsInvoicesModalComponent } from '@ui/lib/shared-modules/modals/transactions-invoices-modal/transactions-invoices-modal.component';
import { NavigationControlsModule } from '@app/shared/ui/components/navigation-controls/module/navigation-controls.module';
import { SummaryAmountModule } from '@ui/lib/shared-components/summary-amount/summary-amount.module';
import { BankStatementUploadModalComponent } from '@ui/lib/shared-modules/modals/bank-statement-upload-modal/bank-statement-upload-modal.component';
import { AddRecipientModalComponent } from '@ui/lib/shared-modules/modals/add-recipient/add-recipient-modal.component';
import { AddExistingRecipientModalComponent } from '@ui/lib/shared-modules/modals/add-existing-recipient/add-existing-recipient-modal.component';
import { DuplicateRecipientModalComponent } from '@ui/lib/shared-modules/modals/duplicate-recipient-modal/duplicate-recipient-modal.component';

const ENTRY_COMPONENTS = [
	DeleteEntityComponent,
	DeleteTaxDocumentComponent,
	DeleteReportComponent,
	ConfirmCloseModalComponent,
	ModalLayoutComponent,
	ViewReportComponent,
	InfoModalComponent,
	InfoLinkModalComponent,
	CreateMultipleEntityComponent,
	ErrorModalComponent,
	ExistingContactComponent,
	DocumentModalComponent,
	NewBillingListComponent,
	MoveReportComponent,
	EditGroupAgreementComponent,
	ManagementSideBarComponent,
	HtmlEditorComponent,
	ConfirmDeleteCommentComponent,
	ConfirmDeleteSharedComponent,
	AddSharedUserComponent,
	SendToComponent,
	ExportReportsModalComponent,
	AddReportBillingListModalComponent,
	ChangeReportStatusComponent,
	BillingCommentComponent,
	CreateUniformComponent,
	DocumentTypeChooseComponent,
	LinkPaymentsComponent,
	LinkedPaymentsModalComponent,
	ConfirmDeleteGeneralRowComponent,
	LinkToPdfTdModalComponent,
	PullEntireBalanceComponent,
	ValidateClosePiComponent,
	NoticeUnlinkPaymentsRefundComponent,
	LinkedDocumentsTdComponent,
	ConfirmSaveNotificationsComponent,
	DashboardSideModalComponent,
	DeleteEntityAdditionalInfoComponent,
	EntityAdditionalInfoModalComponent,
	MigrationsInAppComponent,
	DuplicateEntityModalComponent,
	FolderModalComponent,
	ChangeVatStatusComponent,
	LinkToAgreement,
	BookkeepingPeriodComponent,
	BranchSelectComponent,
	DefaultConfirmCloseComponent,
	CrmProcessComponent,
	AddClauseModalComponent,
	MatterBudgetItemModalComponent,
	AddEntriesToInvoiceComponent,
	ReportingPeriodComponent,
	AddStageModalComponent,
	StageTemplatesModalComponent,
	UpdateClausesModalComponent,
	AddReportsModalComponent,
	AddPersonnelModalComponent,
	AddUserRoleHistoryModalComponent,
	ClientsAndMattersCommentsSideModalComponent,
	CommentsSideModalComponent,
	AddAgreementSplitModalComponent,
	NewReportModalComponent,
	NewConfirmCloseModalComponent,
	IframeModalComponent,
	AddClassifiedUserComponent,
	AddInteractionModalComponent,
	TaskModalComponent,
	ApplyTemplateModalComponent,
	UpdateVatModalComponent,
	IncomeSplitModalComponent,
	AddDocumentsModalComponent,
	GenericFormModalComponent,
	ImportFileModalComponent,
	DatesCalculatorModalComponent,
	AlertModalComponent,
	NewMatterAlertModalComponent,
	NewMobileVersionModalComponent,
	BulkActionModalComponent,
	TransactionsInvoicesModalComponent,
	BankStatementUploadModalComponent,
	RecipientRepositoryModalComponent,
	AddRecipientModalComponent,
	AddExistingRecipientModalComponent,
	DuplicateRecipientModalComponent
];

@NgModule({
	declarations: [...ENTRY_COMPONENTS],
	exports: [],
	imports: [
		CommonModule,
		AppMaterialModule,
		ReactiveFormsModule,
		DirectivesModule,
		CoreModule,
		UiModule,
		NgxMaterialTimepickerModule,
		MatProgressSpinnerModule,
		MatSlideToggleModule,
		RouterModule,
		InputsModule,
		NewUiModule,
		SubmitButtonModule,
		DatepickerInputModule,
		DropdownMenuInputModule,
		FreeTextInputModule,
		AutocompleteModule,
		FileUploaderModule,
		TextareaInputModule,
		TimePickerModule,
		NewSharedModule,
		SuggestionCardModule,
		DropdownModule,
		RadioGroupModule,
		AlertSendingExplanationComponent,
		CheckboxModule,
		TabsModule,
		TextareaInputActionsModule,
		NewDropdownModule,
		RangeCalendarModule,
		RemindersModule,
		IconButtonComponent,
		MaterialSpinnerModule,
		AgGridRootModule,
		NewDynamicFormModule,
		FormLayoutModule,
		NavigationControlsModule,
		SummaryAmountModule
	]
})
export class ModalsModule {}
